import React from "react";
import { Column } from "react-table";
import { TableCustomHeader } from "../../../component/table/components/TableCustomHeader";
import { TableCustomCell } from "../../../component/table/components/TableCustomCell";
import { formatMoney } from "../../../utils/FormatUtils";
import { Formik } from "formik";
import AutocompleteV2 from "../../../component/AutocompleteObjectV2";
import CustomIconButton from "../../../component/custom-icon-button/CustomIconButton";
import { columnNamesType } from "../../../component/table/simple-table/SimpleTable";
import SampleDepartmentCell from "./cells/SampleDepartmentCell";
import FulfillDepartmentCell from "./cells/FulfillDepartmentCell";
import NoteCell from "./cells/NoteCell";
import ObjectTypeCell from "./cells/ObjectTypeCell";
import ActionsCell from "./cells/ActionsCell";
import UnitPriceCell from "./cells/UnitPriceCell";
import IntoMoneyCell from "./cells/IntoMoneyCell";

const DsDichVuColumn: ReadonlyArray<Column<any>> = [
	{
		Header: (props) => (
			<TableCustomHeader<any>
				tableProps={props}
				title={"Mã DV"}
				className="text-center text-transform-none text-light min-w-100px fs-8"
			/>
		),
		id: "Mã dịch vụ",
		Cell: ({ ...props }) => (
			<TableCustomCell className="text-center " data={props?.data[props?.row?.index].code} />
		),
	},
	{
		Header: (props) => (
			<TableCustomHeader<any>
				tableProps={props}
				title={"Tên dịch vụ"}
				className="text-center text-transform-none text-light min-w-300px fs-8"
			/>
		),
		id: "Tên dịch vụ",
		Cell: ({ ...props }) => {
			return <TableCustomCell className="" data={props?.data[props?.row?.index].name} />;
		},
	},
	{
		Header: (props) => (
			<TableCustomHeader<any>
				tableProps={props}
				title={"Số lượng"}
				className="text-center text-transform-none text-light min-w-100px fs-8"
			/>
		),
		id: "Số lượng",
		Cell: ({ ...props }) => {
			return (
				<TableCustomCell
					className="text-center "
					data={props?.data[props?.row?.index].soLuong}
				/>
			);
		},
	},
	{
		Header: (props) => (
			<TableCustomHeader<any>
				tableProps={props}
				title={"Giá BHTY"}
				className="text-center text-transform-none text-light min-w-100px fs-8"
			/>
		),
		id: "Giá BHTY",
		Cell: ({ ...props }) => {
			return (
				<TableCustomCell
					className="text-end "
					data={props?.data[props?.row?.index].giaBHYT}
				/>
			);
		},
	},
	{
		Header: (props) => (
			<TableCustomHeader<any>
				tableProps={props}
				title={"Giá viện phí"}
				className="text-center text-transform-none text-light min-w-120-px fs-8"
			/>
		),
		id: "Giá viện phí",
		Cell: ({ ...props }) => {
			return (
				<TableCustomCell
					className="text-end "
					data={props?.data[props?.row?.index].giaVienPhi}
				/>
			);
		},
	},
	{
		Header: (props) => (
			<TableCustomHeader<any>
				tableProps={props}
				title={"Giá dịch vụ"}
				className="text-center text-transform-none text-light min-w-125px fs-8"
			/>
		),
		id: "Giá dịch vụ",
		Cell: ({ ...props }) => {
			return (
				<TableCustomCell
					className="text-end "
					data={props?.data[props?.row?.index].giaDV}
				/>
			);
		},
	},
	{
		Header: (props) => (
			<TableCustomHeader<any>
				tableProps={props}
				title={"Đơn giá"}
				className="text-center text-transform-none text-light min-w-100px fs-8"
			/>
		),
		id: "Đơn giá",
		Cell: ({ ...props }) => {
			return (
				<TableCustomCell
					className="text-end "
					data={props?.data[props?.row?.index].donGia}
				/>
			);
		},
	},
	{
		Header: (props) => (
			<TableCustomHeader<any>
				tableProps={props}
				title={"Thành tiền"}
				className="text-center text-transform-none text-light min-w-125px fs-8"
			/>
		),
		id: "Thành tiền",
		Cell: ({ ...props }) => {
			return (
				<TableCustomCell
					className="text-end "
					data={props?.data[props?.row?.index].thanhTien}
				/>
			);
		},
	},
	{
		Header: (props) => (
			<TableCustomHeader<any>
				tableProps={props}
				title={"Phòng thực hiện"}
				className="text-center text-transform-none text-light min-w-150px fs-8"
			/>
		),
		id: "Phòng thực hiện",
		Cell: ({ ...props }) => {
			return (
				<TableCustomCell className="" data={props?.data[props?.row?.index].phongThucHien} />
			);
		},
	},
];

const DsDichVuChiDinhColumn: ReadonlyArray<Column<any>> = [
	{
		Header: (props) => (
			<TableCustomHeader<any>
				tableProps={props}
				title={"Thao tác"}
				className="text-center text-transform-none text-light min-w-75px fs-8"
			/>
		),
		id: "Thao tác",
		Cell: ActionsCell,
	},
	{
		Header: (props) => (
			<TableCustomHeader<any>
				tableProps={props}
				title={"STT"}
				className="text-center text-transform-none text-light min-w-40px fs-8"
			/>
		),
		id: "STT",
		Cell: ({ ...props }) => (
			<TableCustomCell className="text-center " data={props?.row?.index + 1} />
		),
	},
	{
		Header: (props) => (
			<TableCustomHeader<any>
				tableProps={props}
				title={"Mã DV"}
				className="text-center text-transform-none text-light min-w-100px fs-8"
			/>
		),
		id: "Mã dịch vụ",
		Cell: ({ ...props }) => <TableCustomCell data={props?.data[props?.row?.index].code} />,
	},
	{
		Header: (props) => (
			<TableCustomHeader<any>
				tableProps={props}
				title={"Tên dịch vụ"}
				className="text-center text-transform-none text-light min-w-250px fs-8"
			/>
		),
		id: "Tên dịch vụ",
		Cell: ({ ...props }) => {
			let data = props?.data[props?.row?.index].name;
			return <TableCustomCell className="spaces max-w-250 text-truncate" data={data} />;
		},
	},
	{
		Header: (props) => (
			<TableCustomHeader<any>
				tableProps={props}
				title={"Đối tượng"}
				className="text-center text-transform-none text-light min-w-125px fs-8"
			/>
		),
		id: "Đối tượng",
		Cell: ObjectTypeCell,
	},
	{
		Header: (props) => (
			<TableCustomHeader<any>
				tableProps={props}
				title={"Số lượng"}
				className="text-center text-transform-none text-light min-w-80px fs-8"
			/>
		),
		id: "Số lượng",
		Cell: ({ ...props }) => {
			let data = props?.data[props?.row?.index]?.attributes?.svcQuantity || 1;
			return <TableCustomCell className="text-center " data={data} />;
		},
	},
	{
		Header: (props) => (
			<TableCustomHeader<any>
				tableProps={props}
				title={"Đơn giá"}
				className="text-center text-transform-none text-light min-w-100px fs-8"
			/>
		),
		id: "Đơn giá",
		Cell: UnitPriceCell,
	},
	{
		Header: (props) => (
			<TableCustomHeader<any>
				tableProps={props}
				title={"Thành tiền"}
				className="text-center text-transform-none text-light min-w-100px fs-8"
			/>
		),
		id: "Thành tiền",
		Cell: IntoMoneyCell,
	},
	{
		Header: (props) => (
			<TableCustomHeader<any>
				tableProps={props}
				title={"Ghi chú"}
				className="text-center text-transform-none text-light min-w-150px fs-8"
			/>
		),
		id: "Ghi chú",
		Cell: NoteCell,
	},
	{
		Header: (props) => (
			<TableCustomHeader<any>
				tableProps={props}
				title={"Phòng thực hiện"}
				className="text-center text-transform-none text-light min-w-250px fs-8"
			/>
		),
		id: "fulfill-department",
		Cell: FulfillDepartmentCell,
	},
	{
		Header: (props) => (
			<TableCustomHeader<any>
				tableProps={props}
				title="Phòng lấy mẫu"
				className="text-center text-transform-none text-light min-w-250px fs-8"
			/>
		),
		id: "sample-department",
		Cell: SampleDepartmentCell,
	},
];

const dsDichVuColumnsSimple: columnNamesType[] = [
	{
		name: "",
		field: "checkbox",
		width: 50,
		minWidth: 27,
	},
	{
		name: "Mã DV",
		field: "code",
		width: 200,
		minWidth: 75,
		textAlign: "center",
		// highlight: true
	},
	{
		name: "Tên dịch vụ",
		field: "name",
		width: 500,
		minWidth: 200,
		textAlign: "left",
		// highlight: true,
	},
	{
		name: "SL",
		field: "svcQuantity",
		width: 90,
		minWidth: 50,
		textAlign: "center",
	},
	{
		name: "Giá BHYT",
		field: "svcFeeIns",
		width: 180,
		minWidth: 75,
		textAlign: "end",
	},
	{
		name: "Giá viện phí",
		field: "svcFeeHospital",
		width: 180,
		minWidth: 80,
		textAlign: "end",
	},
	{
		name: "Giá dịch vụ",
		field: "svcFee",
		width: 180,
		minWidth: 80,
		textAlign: "end",
	},
	{
		name: "Đơn giá",
		field: "svcPrice",
		width: 150,
		minWidth: 70,
		textAlign: "end",
	},
	{
		name: "Phòng thực hiện",
		field: "deptLaboratoryName",
		width: 250,
		minWidth: 110,
	},
];

export { DsDichVuColumn, DsDichVuChiDinhColumn, dsDichVuColumnsSimple };
